export enum TaskTypeActionRequired {
    ALLOWED         = 'allowed',
    DENIED_ON_REPLY = 'denied_on_reply',
    ALWAYS_REQUIRED = 'always_required',
}

export enum TaskTypeReplyButtons {
    REPLY   = 'reply',
    COMMENT = 'comment'
}